import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Vite pulls these from your .env file automatically
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export the auth service and providers for use in your components
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// 🔥 FIXED: Firestore with long polling to stop QUIC_PROTOCOL_ERROR & 400 errors
export const db = getFirestore(app, "(default)", {
    experimentalForceLongPolling: true,     // Forces stable HTTP long-polling instead of QUIC
    // experimentalAutoDetectLongPolling: true,  // Alternative option if needed
});

export default app;